export { default } from './PriceTableModal';
export * from './styled';
